import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Me, UpdateUser } from "../api/users";
import { GetRestaurants } from "../api/restaurant";
import { OpentypeShiftGet } from "../api/type_shift";
import { userShift } from "../api/shift";
import { getFTUser, deleteFTUser, CreateFTUser } from "../api/full_time";
import { MNGLevel } from "../constants";
import { UserShiftMNG } from "../api/mng_shift";

import { GetByDatesMotivation } from "../api/reports/motivation";

const Profile = ({ token, onLogout, userAccessLevel }) => {
  const [shifts, setShifts] = useState([]);
  const [shiftsMNG, setShiftsMNG] = useState([]);
  const [restaurants, setRestaurants] = useState([]);
  const [allRestaurants, setAllRestaurants] = useState();
  const [user, setUser] = useState();
  const [selectedRestaurant, setSelectedRestaurant] = useState(0);
  const [openTypeShifts, setOpentypeShifts] = useState();
  const [modalMessage, setModalMessage] = useState("");
  const [Loading, setLoading] = useState(true);
  const [haveFT, setHaveFT] = useState(false);
  const [idFT, setIdFT] = useState("");
  const [userRestaurant, setUserRestaurant] = useState("");
  const [motivateTable, setMotivateTable] = useState(null);

  const DefaultFields = [
    ["result_OSAT", "show_name", ""],
    ["premium_OSAT", "show_name 2", ""],
    ["result_POST", "show_name 2", ""],
    ["premium_POST", "show_name 2", ""],
    ["result_TMT", "show_name 2", ""],
    ["premium_TMT", "show_name 2", ""],
    ["result_POSTMOSCOW", "show_name 2", ""],
    ["premium_POSTMOSCOW", "show_name 2", ""],
    ["result_EBITDA", "show_name 2", ""],
    ["premium_EBITDA", "show_name 2", ""],
    ["summa", "show_name 2", ""],
    ["premium_col", "show_name 2", ""],
    ["col", "show_name 2", ""],
    ["to", "show_name 2", ""],
    ["fot", "show_name 2", ""],
    ["fot_del_to", "show_name 2", ""],
    ["premium_OSAT_zam", "show_name 2", ""],
    ["premium_POST_zam", "show_name 2", ""],
    ["premium_TMT_zam", "show_name 2", ""],
    ["premium_POSTMOSCOW_zam", "show_name 2", ""],
    ["premium_EBITDA_zam", "show_name 2", ""],
    ["premium_col_zam", "show_name 2", ""],
    ["summa_zam", "show_name 2", ""],
  ];

  const fetchProfile = async () => {
    try {
      setLoading(true);

      const user = await Me(token);
      setUser(user);
      console.log(user, "user");
      setUserRestaurant(user.restaurant_name);
      const restaurants = await GetRestaurants(token, 1, 50);
      const typeShifts = await OpentypeShiftGet(token);
      setOpentypeShifts(typeShifts);
      setAllRestaurants(restaurants);
      setLoading(false);
      const today = new Date();
      const sevenDaysAgo = new Date(today);
      sevenDaysAgo.setDate(today.getDate() - 7);

      const sevenDaysLater = new Date(today);
      sevenDaysLater.setDate(today.getDate() + 7);
      const shiftList = [];
      const shiftsMNGList = [];
      const shiftsResponse = await userShift(
        token,
        user.id,
        formatDate(sevenDaysAgo),
        formatDate(sevenDaysLater),
      );
      const shiftsMNGResponse = await UserShiftMNG(
        token,
        user.id,
        formatDate(sevenDaysAgo),
        formatDate(sevenDaysLater),
      );
      for (let shift of shiftsResponse) {
        shiftList.push(shift);
      }
      for (let shift of shiftsMNGResponse) {
        shiftsMNGList.push(shift);
      }
      setShifts(shiftList);
      setShiftsMNG(shiftsMNGList);
      let dates = getNextWeekRange();
      let startDate = dates["nextMonday"];
      let endDate = dates["nextSunday"];
      if (user.post_access_level < MNGLevel) {
        const ftUser = await getFTUser(token, startDate, endDate, user.id);
        if (ftUser) {
          setHaveFT(true);
          setIdFT(ftUser.id);
        }
      }

      if (user.post_access_level === 11 || user.post_access_level === 12) {
        const { start, end } = getLastMonthRange();
        const data = await GetByDatesMotivation(token, start, end);
        renderTable(data, user.post_access_level);
      }
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchProfile();
  }, [token]);

  async function deleteFT(event) {
    const data = await deleteFTUser(token, idFT);
    setHaveFT(false);
  }

  async function createFT(event) {
    const data = await CreateFTUser(token);
    setHaveFT(true);
    setIdFT(data.id);
  }

  function renderShifts() {
    if (shifts.length > 0) {
      return shifts.map((shift) => (
        <tr className="text-center" key={shift.id}>
          <td>{shift.date}</td>
          <td>{getRussianWeekday(shift.date)}</td>
          <td>
            {shift.start} - {shift.end}
          </td>
          <td>{shift.station_name}</td>
          <td>{shift.restaurant_name}</td>
        </tr>
      ));
    } else if (shiftsMNG.length > 0) {
      let dictRest = {};
      let dictTypeShift = {};
      for (let rest of allRestaurants.data) {
        dictRest[rest.id] = rest.name;
      }
      for (let typeShift of openTypeShifts) {
        dictTypeShift[typeShift.id] = typeShift.name;
      }

      return shiftsMNG.map((shift) => (
        <tr className="text-center" key={shift.id}>
          <td>{shift.date}</td>
          <td>{getRussianWeekday(shift.date)}</td>
          <td>
            {shift.start} - {shift.end}
          </td>
          <td>
            {shift.type_shift_id !== 1
              ? dictTypeShift[shift.type_shift_id]
              : shift.name}
          </td>
          <td>{dictRest[shift.restaurant_id]}</td>
        </tr>
      ));
    }

    return (
      <tr>
        <td colSpan={5} className="profile-empty-cell">
          Нет смен на ближайшие дни
        </td>
      </tr>
    );
  }

  async function changeRestaurant() {
    const data = await UpdateUser(token, {
      id: user.id,
      restaurant_id: selectedRestaurant,
    });
    if (data.detail) {
      setModalMessage(<p style={{ color: "red" }}>{data.detail}</p>);
    } else {
      setModalMessage(<p style={{ color: "green" }}> Успешно!</p>);
    }
    for (let rest of allRestaurants.data) {
      if (rest.id == selectedRestaurant) {
        setUserRestaurant(rest.name);
      }
    }
  }

  function renderTable(data, level) {
    if (!data) {
      return;
    }
    console.log(data);

    for (let field of DefaultFields) {
      console.log(field);
      for (let repField of data[0].fields) {
        if (field[0] == repField[0]) {
          field[2] = repField[2];
          break;
        }
      }
    }
    const fields = DefaultFields;
    setMotivateTable(
      <div className="profile-card profile-motivation">
        <h4 className="profile-section-title">Мотивация</h4>
        <div className="table-responsive">
          <table className="table table-bordered text-center profile-data-table">
            <thead>
              <tr>
                <th></th>
                <th>Цель</th>
                <th>Результат</th>
                <th>Премия</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1. OSAT</td>
                <td> &gt; 85</td>
                <td>{fields[0][2]}</td>
                {level === 12 ? (
                  <td>{fields[1][2]}</td>
                ) : (
                  <td>{fields[16]?.[2]}</td>
                )}
              </tr>

              <tr>
                <td>2. РОСТ самоаудит</td>
                <td>at standart</td>
                <td>{fields[2][2]}</td>
                {level === 12 ? (
                  <td>{fields[3][2]}</td>
                ) : (
                  <td>{fields[17]?.[2]}</td>
                )}
              </tr>
              <tr>
                <td>3. TMT</td>
                <td> &lt;= 90</td>
                <td>{fields[4][2]}</td>
                {level === 12 ? (
                  <td>{fields[5][2]}</td>
                ) : (
                  <td>{fields[18]?.[2]}</td>
                )}
              </tr>

              <tr>
                <td>4. РОСТ Москва T</td>
                <td>at standart</td>
                <td>{fields[6][2]}</td>
                {level === 12 ? (
                  <td>{fields[7][2]}</td>
                ) : (
                  <td>{fields[19]?.[2]}</td>
                )}
              </tr>

              <tr>
                <td>5. EBITDA</td>
                <td>Индивидуально</td>
                <td>{fields[8][2]}</td>
                {level === 12 ? (
                  <td>{fields[9][2]}</td>
                ) : (
                  <td>{fields[20]?.[2]}</td>
                )}
              </tr>

              <tr>
                <td>6. COL</td>
                <td>{fields[12][2]}</td>
                <td>{fields[15][2]}</td>
                {level === 12 ? (
                  <td>{fields[11][2]}</td>
                ) : (
                  <td>{fields[21]?.[2]}</td>
                )}
              </tr>

              <tr>
                <td>Сумма</td>
                {level === 12 ? (
                  <td colSpan={3}>{fields[10][2]}</td>
                ) : (
                  <td colSpan={3}>{fields[22]?.[2]}</td>
                )}
              </tr>
            </tbody>
          </table>
        </div>
      </div>,
    );
  }

  const menuItems = [
    userAccessLevel < 10 && { to: "/add-shift", label: "Записаться на смену" },
    userAccessLevel < 20 && { to: "/record-food", label: "Записать прием пищи" },
    userAccessLevel >= 20 && {
      to: "/loading-template-shift",
      label: "Шаблоны смен",
    },
    userAccessLevel >= 10 && { to: "/TO", label: "ТО" },
    userAccessLevel >= 20 && { to: "/users-edit", label: "Сотрудники" },
    userAccessLevel >= 10 && { to: "/schedule-chk", label: "Расписание ЧК" },
    userAccessLevel >= 10 && { to: "/schedule-mng", label: "Расписание МНГ" },
    userAccessLevel >= 10 && { to: "/reports", label: "Отчеты" },
    userAccessLevel >= 10 && { to: "/check_dep", label: "Проверить ДЕП" },
    userAccessLevel >= 12 && { to: "/auto-dep", label: "Автодеп" },
    { to: "/change-your-password", label: "Сменить пароль" },
  ].filter(Boolean);

  return (
    <div className="profile-page">
      <div className="profile-layout">
        <aside className="profile-sidebar">
          {Loading ? (
            <div className="profile-card profile-loading">
              <div className="spinner-border profile-spinner" role="status">
                <span className="visually-hidden">Загрузка...</span>
              </div>
              <p>Загрузка профиля...</p>
            </div>
          ) : (
            <>
              <div className="profile-card profile-user-card">
                <div className="profile-avatar">
                  {(user?.surname?.[0] || "").toUpperCase()}
                  {(user?.name?.[0] || "").toUpperCase()}
                </div>
                <div className="profile-user-meta">
                  <h2 className="profile-user-name">
                    {user.surname} {user.name}
                  </h2>
                  <p className="profile-user-role">{user.post_name}</p>
                  <p className="profile-user-rest">{userRestaurant}</p>
                  <p className="profile-user-city">Саратов</p>
                </div>
              </div>

              <nav className="profile-card profile-nav">
                <p className="profile-nav-title">Меню</p>
                <ul className="profile-nav-list">
                  {menuItems.map((item) => (
                    <li key={item.to}>
                      <Link className="profile-nav-link" to={item.to}>
                        {item.label}
                      </Link>
                    </li>
                  ))}
                </ul>
                <button
                  type="button"
                  className="profile-logout-btn"
                  onClick={onLogout}
                >
                  Выйти
                </button>
              </nav>
            </>
          )}
        </aside>

        <section className="profile-main">
          {motivateTable}

          <div className="profile-card">
            <div className="profile-section-head">
              <h3 className="profile-section-title">Расписание</h3>
              <p className="profile-section-hint">
                Смены за ±7 дней от сегодня
              </p>
            </div>

            <div className="table-responsive">
              <table className="table table-bordered profile-data-table">
                <thead>
                  <tr>
                    <th className="text-center">Дата</th>
                    <th className="text-center">День недели</th>
                    <th className="text-center">Время</th>
                    <th className="text-center">Станция</th>
                    <th className="text-center">Ресторан</th>
                  </tr>
                </thead>
                <tbody>{!Loading && renderShifts()}</tbody>
              </table>
            </div>

            {userAccessLevel < MNGLevel && (
              <div className="profile-ft-actions">
                {haveFT ? (
                  <button
                    className="btn profile-btn-secondary"
                    type="button"
                    onClick={deleteFT}
                  >
                    Отозвать FT на следующую неделю
                  </button>
                ) : (
                  <button
                    className="btn profile-btn-primary"
                    type="button"
                    onClick={createFT}
                  >
                    Стать FT!
                  </button>
                )}
              </div>
            )}
          </div>
        </section>
      </div>

      <div
        className="modal fade"
        id="staticBackdrop"
        tabIndex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header justify-content-center">
              <h5 className="modal-title text-center" id="staticBackdropLabel">
                Информация
              </h5>
            </div>
            <div className="modal-body">
              <select
                className="form-select"
                aria-label="Default select example"
                value={selectedRestaurant}
                onChange={(e) => setSelectedRestaurant(e.target.value)}
              >
                <option value={0}>Выберите Ресторан</option>
                {restaurants.map((rest) => (
                  <option key={rest.id} value={rest.id}>
                    {rest.name}
                  </option>
                ))}
              </select>
              <button className="btn" onClick={changeRestaurant}>
                Сохранить
              </button>
              {modalMessage}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Profile;

function getRussianWeekday(dateString) {
  const days = [
    "воскресенье",
    "понедельник",
    "вторник",
    "среда",
    "четверг",
    "пятница",
    "суббота",
  ];
  const date = new Date(dateString);
  if (isNaN(date.getTime())) {
    return "Некорректная дата";
  }
  const dayOfWeek = date.getDay();
  return days[dayOfWeek];
}

function getNextWeekRange() {
  const today = new Date();
  const nextMonday = new Date(
    today.setDate(today.getDate() + ((8 - today.getDay()) % 7)),
  );
  const nextSunday = new Date(nextMonday);
  nextSunday.setDate(nextMonday.getDate() + 6);

  return {
    nextMonday: nextMonday.toISOString().split("T")[0],
    nextSunday: nextSunday.toISOString().split("T")[0],
  };
}

const formatDate = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

function getLastMonthRange() {
  const now = new Date();
  const currentYear = now.getFullYear();
  const currentMonth = now.getMonth();

  let lastMonth = currentMonth - 1;
  let year = currentYear;

  if (lastMonth < 0) {
    lastMonth = 11;
    year = currentYear - 1;
  }

  const firstDay = new Date(year, lastMonth, 1);
  const lastDay = new Date(year, lastMonth + 1, 0);

  const formatDate = (date) => {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, "0");
    const d = String(date.getDate()).padStart(2, "0");
    return `${y}-${m}-${d}`;
  };

  return {
    start: formatDate(firstDay),
    end: formatDate(lastDay),
  };
}
